export const PRIVATE_PROFILE_DATA_QUERY_KEY = ['profile', 'private-data'];
export const PUBLIC_PROFILE_DATA_QUERY_KEY = ['profile', 'public-data'];
export const PRIVATE_REQUEST_PATHNAME = 'profile/me';
export const PUBLIC_REQUEST_PATHNAME = 'profile/public';

export const PROFILE_EDIT_FORM_FIELDS = {
  NICKNAME: 'nickname',
  ABOUT: 'about',
} as const;
